var omjs          = require("./omjs"),
    projectFabric = require("./Project/fabric"),
    Project       = require("./Project/Project"),
    Container     = require('./Project/Container'),
    ContainersCollection     = require('./Project/ContainersCollection'),
    Layer         = require('./Project/Layer'),
    Visualization = require('./Project/Visualization'),
    LayerObject   = require('./Project/LayerObject');


omjs.initProject = projectFabric;

/**
 * @property {omjs.Project} Project
 */
omjs.Project = Project;

omjs.Project.ContainersCollection   = ContainersCollection;

/**
 * {{#crossLink "omjs.Project.Container"}} Описание класса omjs.Project.Container{{/crossLink}}
 *
 * @property {omjs.Project.Container} Project.Container
 */
omjs.Project.Container = Container;

/**
 * {{#crossLink "omjs.Project.Layer"}} Описание класса omjs.Project.Layer{{/crossLink}}
 *
 * @property {omjs.Project.Layer} Project.Layer
 */
omjs.Project.Layer = Layer;
omjs.Project.Visualization = Visualization;
omjs.Project.LayerObject   = LayerObject;

module.exports = omjs;


//////////////////
// WEBPACK FOOTER
// ./src/omjs.project.js
// module id = 1
// module chunks = 0